'use strict';

/**
 *
 * @name: heartRate
 *
 */

import DirectiveTemplate from './nn-heart-rate.directive.html';

function HeartRateDirective(
  $rootScope,
  $timeout,
  apiLoveService,
  playersAnalytics,
  playlistAnalytics,
  nnModalsService
) {

  'ngInject';

  // ATTENZION!
  // THE TIMEOUT FOR JUSTRATEDFIVESTARS IS IN THE MAIN CONTROLLER!

  return {
    replace: true,
    template: DirectiveTemplate,
    scope: {
      enforceUserRating: '@',
      anotherUser: '@',
      onPlaylist: '@',
      post: '=',
      playlist: '=',
      allowEdit: '@',
      isItLarge: '@',
      dropdown: '=',
      comment: '=',
      noShare: '='
    },
    link: function heartRateLink(scope, element) {

      var rootWatchers = {};
      scope.settings = {
        alreadyChanged: false
      };

      scope.isJustRatedFiveStars = function(postId) {

        return $rootScope.justRatedFiveStarsPostId === postId;
      };

      setHeartRate();
      var heartRateGoCompile;
      var loadItInBackground;
      var ratingControl;
      var tooltops;

      function changeAverage() {

        if (scope.enforceUserRating) {
          // for contributor page we need to enforce avg rating to 5
          // see: https://app.asana.com/0/20936460556629/34998051836178
          // and https://app.asana.com/0/14598104285478/34376415027237
          scope.entity.userRating = scope.enforceUserRating;
          scope.averageRating = parseFloat(scope.enforceUserRating);

        } else if (scope.entity && !scope.anotherUser && scope.entity['lovesCount_' + $rootScope.lang2]) {

          scope.averageRating = Math.round(10 * scope.entity['rating_' + $rootScope.lang2] / scope.entity['lovesCount_' + $rootScope.lang2]) / 10;
          $timeout(function() {

            if(scope.entity.id === $rootScope.post.id){
              $rootScope.post.averageRating = Math.round(10 * scope.entity['rating_' + $rootScope.lang2] / scope.entity['lovesCount_' + $rootScope.lang2]) / 10;
            }
          });
        } else if (scope.anotherUser && scope.entity && !scope.comment) {

          scope.averageRating = scope.entity.userRating;
        } else if (scope.anotherUser && scope.entity && scope.comment) {

          scope.averageRating = scope.comment.commenterRating;
        } else {

          scope.averageRating = 0;
        }
      }

      var changeAverageWatcher = $rootScope.$on('changeAverage', changeAverage);

      function setHeartRate() {

        // clear everything
        ratingControl = null;
        tooltops = null;
        element.find('.current-rating').off('mouseenter mouseleave');
        element.find('.current-rating').off('click');
        tooltops = element.find('.rating-tooltops');
        ratingControl = element.find('.rating-control');
        ratingControl.off('click');

        if (heartRateGoCompile) {

          heartRateGoCompile();
        }
        if (loadItInBackground) {

          loadItInBackground();
        }

        heartRateGoCompile = $rootScope.$on('goCompile', function() {

          $timeout(function() {

            setHeartRate();
          });
        });

        loadItInBackground = $rootScope.$on('reloadRates', function() {

          $timeout(function() {

            setHeartRate();
          });
        });

        if (scope.allowEdit === 'false') {

          scope.allowEdit = false;
        }

        if (scope.post && scope.post.id) {

          scope.entity = scope.post;
        } else if (scope.playlist && scope.playlist.id) {

          scope.entity = scope.playlist;
        }

        changeAverage();

        if (scope.allowEdit === 'onlyEdit') {

          ratingControl.css('visibility', 'visible');
        } else {

          ratingControl.addClass('no-edit');
        }

        if (scope.isItLarge) {
          element.addClass('large');
        }

        if (scope.allowEdit !== 'onlyEdit' && (!scope.allowEdit || $rootScope.isMobileDevice)) {

          ratingControl.addClass('no-edit');
        }

        if (scope.allowEdit && (scope.post || scope.playlist)) {

          element.find('.current-rating').on('click', function(e) {

            if (!$rootScope.profile) {

              e.stopPropagation();
              rootWatchers.profile = $rootScope.$watch('profile', function(newVal) {

                if (newVal) {

                  rootWatchers.profile();
                  element.find('.current-rating').off('click');
                  $rootScope.loadItInBackground();
                }
              });

              $rootScope.postToLove = scope.post;
              $rootScope.toBeLoved = true;
              nnModalsService.showModal('login')

              setTimeout(function() {

                scope.$apply();
              });
            }
          });
        }

        if (scope.allowEdit &&
          (!$rootScope.isMobileDevice || scope.allowEdit === 'onlyEdit' || scope.onPlaylist) &&
          (scope.post || scope.playlist) &&
          $rootScope.profile) {

          var handleOver = function(e) {

            var tooltip;
            tooltops = element.find('.rating-tooltops');
            tooltops.children('.rate').removeClass('visible');

            if (scope.playlist) {

              tooltops.css('display', e.type === 'mouseenter' ? 'block' : 'none');
            }

            if (!scope.entity.isLoved && !scope.entity.userRating) {

              tooltip = tooltops.children('.rate');
            } else {

              tooltip = tooltops.children('.edit-rating');
              tooltops.children('.avg').toggleClass('become-invisible', e.type === 'mouseenter');
            }
            if (scope.allowEdit === 'true') {

              ratingControl.css('display', e.type === 'mouseenter' ? 'block' : 'none');
              ratingControl.toggleClass('no-edit', e.type !== 'mouseenter');
              tooltip.toggleClass('visible', e.type === 'mouseenter');
            }
          };

          element.find('.current-rating').on('mouseenter mouseleave', handleOver);

          var afterClickTimeout;

          ratingControl.on('click', 'i', function(e) {

            e.stopPropagation();

            if (afterClickTimeout) {

              $timeout.cancel(afterClickTimeout);
            }

            var rate = 5 - $(this).index();
            element.attr('data-user-rating', rate);
            tooltops.children('.rate').removeClass('visible');
            tooltops.children('.my-rating').addClass('visible');
            var oldUserRating;

            if (scope.post) {

              if (rate === 5 && !scope.comment && !scope.noShare) {

                $rootScope.ratingsJustRatedFiveStars = true;
                $rootScope.justRatedFiveStarsPostId = scope.post.id;
              }
              if (rate !== 5) {

                $rootScope.ratingsJustRatedFiveStars = false;
              }
              if (rate === 1) {

                $rootScope.ratingsJustRatedOneStar = true;
              }
              if (rate !== 1) {

                $rootScope.ratingsJustRatedOneStar = false;
              }

              if (scope.post.userRating || scope.post.userRating === 0) {

                oldUserRating = scope.post.userRating;

                apiLoveService
                  .loveUpdate(scope.post.id, rate)
                  .then(function() {

                    scope.post.userRating = rate;
                    scope.post['rating_' + $rootScope.lang2] = scope.post['rating_' + $rootScope.lang2] - oldUserRating + rate;

                    if (oldUserRating === 0) {

                      scope.post['lovesCount_' + $rootScope.lang2]++;
                    }

                    $rootScope.$broadcast('changeAverage');

                  });
              } else {

                apiLoveService
                  .lovePost(scope.post.id, rate)
                  .then(function() {

                    scope.post.userRating = rate;
                    scope.post.isLoved = true;
                    scope.post['rating_' + $rootScope.lang2] = scope.post['rating_' + $rootScope.lang2] + rate;
                    scope.post['lovesCount_' + $rootScope.lang2]++;
                    $rootScope.$broadcast('changeAverage');
                  });
              }

              playersAnalytics.videoAction('Rating');
            } else if (scope.playlist) {

              if (scope.playlist.userRating || scope.playlist.userRating === 0) {

                oldUserRating = scope.playlist.userRating;

                apiLoveService
                  .lovePlaylistUpdate(scope.playlist.id, rate)
                  .then(function() {

                    scope.playlist.userRating = rate;
                    scope.playlist['rating_' + $rootScope.lang2] = scope.playlist['rating_' + $rootScope.lang2] - oldUserRating + rate;

                    if (oldUserRating === 0) {

                      scope.playlist['lovesCount_' + $rootScope.lang2]++;
                    }

                    $rootScope.$broadcast('changeAverage');
                  });
              } else {

                apiLoveService
                  .lovePlaylist(scope.playlist.id, rate)
                  .then(function() {

                    scope.playlist.userRating = rate;
                    scope.playlist.isLoved = true;
                    scope.playlist['rating_' + $rootScope.lang2] = scope.playlist['rating_' + $rootScope.lang2] + rate;
                    scope.playlist['lovesCount_' + $rootScope.lang2]++;
                    $rootScope.$broadcast('changeAverage');
                  });
              }

              playlistAnalytics.rate('Playlist page', scope.playlist.translations[$rootScope.lang].title);
            }

            element.find('.current-rating').off('mouseenter mouseleave');
            element.find('.rating-tooltops > div').removeClass('visible');

            afterClickTimeout = $timeout(function() {

              if (scope.allowEdit === 'true') {

                ratingControl.css('display', 'none');
                ratingControl.removeClass('visible');
                element.find('.current-rating').on('mouseenter mouseleave', handleOver);
              }

              if (scope.onPlaylist) {

                scope.settings.alreadyChanged = false;
              }
            }, 2000);
          });
        }

        scope.$on('$destroy', function() {

          heartRateGoCompile();
          loadItInBackground();

          Object.keys(rootWatchers)
            .forEach(function(killWatcherKey) {

              rootWatchers[killWatcherKey]();
            });

          changeAverageWatcher();
          element.find('.current-rating').off('mouseenter mouseleave');

          if (ratingControl) {

            ratingControl.off('click');
          }

          ratingControl = null;
          tooltops = null;
        });
      }
    }
  };
}

export default HeartRateDirective;



// WEBPACK FOOTER //
// ./app/components/nn-generic-directives/nn-heart-rate/nn-heart-rate.directive.js